import { Breakpoints } from "../types/types";


export const breakpoints: Breakpoints = {
  isMobile: '(max-width: 767px)',
  isTablet: '(min-width: 768px) and (max-width: 1200px)',
  isDesktopSmall: '(min-width: 1201px) and (max-width: 1500px)',
  isDesktop: '(min-width: 1501px)  and (max-width: 2570px)',
  isFourK: '(min-width: 2571px)'
};

export const showLanguageButtons = true; 